export default __webpack_public_path__ + "static/media/Create-documentation.b2e8a011.md";